import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useMobileMenuReset } from "../Utils/useMobileMenuReset";
import { resetMobileMenuState } from "../Utils/active.js";

function Header() {
  // Use the custom hook to automatically reset mobile menu on navigation

  useMobileMenuReset();

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }

    // Add click handlers to all navigation links to close mobile menu
    const handleNavLinkClick = () => {
      resetMobileMenuState();
    };

    const navLinks = document.querySelectorAll(
      ".navbar-nav a, .navbar-nav .magnet-link"
    );
    navLinks.forEach((link) => {
      link.addEventListener("click", handleNavLinkClick);
    });

    // Add click outside handler for this specific header
    const handleClickOutside = (event) => {
      const navbar = document.querySelector(".header-area .navbar");
      const navbarCollapse = document.querySelector(
        ".header-area .navbar-collapse"
      );

      if (navbar && navbarCollapse) {
        if (navbarCollapse.classList.contains("show")) {
          if (!navbar.contains(event.target)) {
            resetMobileMenuState();
          }
        }
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      navLinks.forEach((link) => {
        link.removeEventListener("click", handleNavLinkClick);
      });
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Ensure a Collapse instance exists and sync aria-expanded with events
  useEffect(() => {
    const collapseEl = document.getElementById("lawgisNav");
    const toggler = document.querySelector(".header-area .navbar-toggler");
    const CollapseCtor = window.bootstrap && window.bootstrap.Collapse;

    if (!collapseEl || !CollapseCtor) return;

    const instance = CollapseCtor.getOrCreateInstance(collapseEl, {
      toggle: false,
    });

    const onShown = () => {
      if (toggler) toggler.setAttribute("aria-expanded", "true");
    };
    const onHidden = () => {
      if (toggler) toggler.setAttribute("aria-expanded", "false");
      // Cleanup any transient styles/classes
      collapseEl.classList.remove("collapsing");
      collapseEl.style.height = "";
      collapseEl.style.overflow = "";
    };

    collapseEl.addEventListener("shown.bs.collapse", onShown);
    collapseEl.addEventListener("hidden.bs.collapse", onHidden);

    return () => {
      collapseEl.removeEventListener("shown.bs.collapse", onShown);
      collapseEl.removeEventListener("hidden.bs.collapse", onHidden);
    };
  }, []);

  return (
    <div>
      {/* Search Form */}
      <div className="search-bg-overlay" id="searchOverlay"></div>
      <div className="search-form-popup">
        <h2 className="mb-4">How can I help you, Today?</h2>
        <button
          type="button"
          className="close-btn"
          id="searchClose"
          aria-label="Close"
        >
          &times;
        </button>
        <form className="search-form">
          <input
            type="search"
            className="form-control"
            placeholder="Search..."
            id="site-search"
            name="q"
          />
          <button type="submit" className="btn btn-primary">
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
            <span>
              <i className="ti ti-search"></i> Search Now
            </span>
          </button>
        </form>
      </div>
      {/* Header Area*/}
      <header className="header-area">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Navbar Brand */}
            <Link to="/" className="navbar-brand" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <img src="assets/img/paraclearth-logo.jpeg" alt="Paraclearth" style={{ height: "40px", width: "auto" }} />
              <span style={{ fontWeight: 700, fontSize: "1.25rem", color: "#ffffff" }}>Paraclearth LP</span>
            </Link>

            {/* Navbar Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              aria-controls="lawgisNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={(e) => {
                const collapseEl = document.getElementById("lawgisNav");
                const CollapseCtor =
                  window.bootstrap && window.bootstrap.Collapse;
                if (!collapseEl || !CollapseCtor) return;
                const collapse = CollapseCtor.getOrCreateInstance(collapseEl, {
                  toggle: false,
                });
                const isOpen = collapseEl.classList.contains("show");
                if (isOpen) {
                  collapse.hide();
                  e.currentTarget.setAttribute("aria-expanded", "false");
                } else {
                  collapse.show();
                  e.currentTarget.setAttribute("aria-expanded", "true");
                }
              }}
            >
              <i className="ti ti-category"></i>
            </button>

            {/* Navbar Nav */}
            <div
              className="collapse navbar-collapse justify-content-end"
              id="lawgisNav"
            >
              <ul className="navbar-nav navbar-nav-scroll">
                <li className="lawgis-dd">
                  <Link to="/aboutus" className="magnet-link">
                    The Firm <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link to="/aboutus" className="magnet-link">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/team" className="magnet-link">
                        Our People
                      </Link>
                    </li>
                    <li>
                      <Link to="/contactone" className="magnet-link">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lawgis-dd">
                  <Link to="/service" className="magnet-link">
                    Expertise <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link to="/service" className="magnet-link">
                        Capabilities
                      </Link>
                    </li>
                    <li>
                      <Link to="/casestudy" className="magnet-link">
                        Sectors
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lawgis-dd">
                  <Link to="/blogone" className="magnet-link">
                    Resources <i className="ti ti-chevron-down"></i>
                  </Link>
                  <ul className="lawgis-dd-menu">
                    <li>
                      <Link to="/blogone" className="magnet-link">
                        Media &amp; Insights
                      </Link>
                    </li>
                    <li>
                      <Link to="/case-studies" className="magnet-link">
                        Case Studies
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="aaer-nav-item">
                  <Link to="/aaer-legal-technology" className="magnet-link">
                    AAER
                  </Link>
                </li>
              </ul>

              <div className="d-flex align-items-center">
                {/* Login Button */}

                <Link to="/bookconsultation" className="btn btn-primary">
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default Header;
